import { Stack, Text } from '@mantine/core';

interface IChatRoomEmptyStateProps {
  size?: 'sm' | 'md';
}

export function ChatRoomEmptyState({ size = 'md' }: IChatRoomEmptyStateProps) {
  const isNormalSize = size === 'md';

  return (
    <Stack gap="0.1rem" maw={isNormalSize ? '22rem' : '18rem'}>
      <Text fw="bold" ta="center" fz={isNormalSize ? 'xl' : 'lg'}>
        Mulai Obrolan!
      </Text>
      <Text ta="center" c="dimmed" fz={isNormalSize ? 'sm' : 'xs'}>
        Pilih percakapan disamping untuk mulai mengobrol
      </Text>
    </Stack>
  );
}
